import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { IClient } from '../../models/client.model';
import * as clientSelector from '../../ngrx/reducers/client.reducer';

@Component({
  selector: 'app-not-found',
  templateUrl: 'not-found.html'
})
export class NotFoundComponent {

  @Input() state: boolean;
  @Input() messageNotFound: string = 'Not found data';
  @Input() messageNotFound2: string;
  @Input() config: any;

  client$: Observable<IClient>;

  constructor(
    private store: Store<{}>
  ) { }

  ngOnInit() {
    this.client$ = this.store.select(clientSelector.getClient);
  }
}



// WEBPACK FOOTER //
// ./src/components/not-found/not-found.ts